import React, { Component } from "react"

import { connect } from "react-redux"
import { translate } from "react-translate"
import { Link, withRouter } from "react-router-dom"

import {
  Segment,
  Grid,
  Menu,
  Image,
  Header,
  Icon,
  Modal,
  Button,
  Item
} from "semantic-ui-react"

//import MenuEdition from "../DevisFactures/EditionDevisFactures/MenuEdition"
import BandeauNoir from "../Entete/BandeauNoir"
import BouttonEntete from "../Entete/BouttonEntete"
import "./MenuEntete.css"
import { circleDown } from "react-icons-kit/icomoon/circleDown"
import { arrowLeft2 } from "react-icons-kit/icomoon/arrowLeft2"

const mapStateToProps = state => ({
  app: state.app
})

class MenuEntete extends Component {
  constructor(props) {
    super(props)
    console.log("Props", props)

    this.state = {
      dateDevisFacturesData: [{ dateEnteteBody: "Janvier 2017 :" }],
      activeItem: "En-têtes"
    }
  }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  componentWillMount() {
    this.goBack = window.history.go
  }

  render() {
    let { t, history } = this.props
    const { activeItem } = this.state
    console.log("history", history)
    return (
      <Segment id="main">
        <BandeauNoir>
        
          <BouttonEntete
            text={t("button_bandeau_exit")}
            style="bouttonEnteteParametre1"
            icon={arrowLeft2}
            onClick={() => {
              console.log("object")
              history.goBack()
            }}
          />

          <BouttonEntete
            text={t("button_bandeau_save")}
            style="bouttonEnteteParametre2"
            icon={circleDown}
          />

          <hr id="hrParametre" />
          <Segment inverted id="menuEdition">
            <Menu inverted pointing secondary id="MenuBlock">
              <Link to={{ pathname: "/mtpro/parametre/Entete" }}>
                <Menu.Item
                  active={activeItem === "En-têtes"}
                  onClick={this.handleItemClick}
                  name={t("title_menu_entete")}
                  nameIcon="caret square up"
                  id="itemEdition"
                />
              </Link>
              <Link to={{ pathname: "/mtpro/parametre/footer" }}>
                <Menu.Item
                  active={activeItem === "Pieds de page"}
                  onClick={this.handleItemClick}
                  name={t("title_menu_pied")}
                  nameIcon="caret square down"
                  id="itemEdition"
                />
              </Link>
              <Link to={{ pathname: "/mtpro/parametre/devisfacture" }}>
                <Menu.Item
                  active={activeItem === "Devis et factures"}
                  onClick={this.handleItemClick}
                  name={t("title_menu_devisfacture")}
                  nameIcon="file alternate outline"
                  id="itemEdition"
                />
              </Link>
              <Link to={{ pathname: "/mtpro/parametre/entreprise" }}>
                <Menu.Item
                  active={activeItem === "Mon entreprise"}
                  onClick={this.handleItemClick}
                  name={t("title_menu_entreprise")}
                  nameIcon="briefcase"
                  id="itemEdition"
                />
              </Link>
            </Menu>
          </Segment>
        </BandeauNoir>
      </Segment>
    )
  }
}

const HomeComponent = connect(mapStateToProps)(MenuEntete)
export default withRouter(translate("ProParamHomeComponent")(HomeComponent))



// WEBPACK FOOTER //
// ./src/components/Pro/Parametres/MenuEntete.js